import { baseClasses } from '@weatherbug/common';
import { EmUserProfile, IAuthUserInfo } from '../../components/common/interfaces/types';
import { AuthProvider } from '../providers/authProvider';

const { AsyncAction } = baseClasses;

export const SET_AUTHENTICATED_USER_DATA = 'SET_AUTHENTICATED_USER_DATA';
export const AUTH_LOGIN = new AsyncAction('AUTH_LOGIN');
export const DID_SET_USER_PREFERENCES = 'DID_SET_USER_PREFERENCES';
export const RESET_LOGGED_OUT_USER_DATA = 'RESET_LOGGED_OUT_USER_DATA';

export type ResetLoggedOutUserActionType = {
    type: typeof RESET_LOGGED_OUT_USER_DATA;
    payload?: unknown;
}

export type DidSetUserPreferencesType = {
    type: typeof DID_SET_USER_PREFERENCES;
    payload: boolean;
}

export type SetAuthUserDataType = {
    type: typeof SET_AUTHENTICATED_USER_DATA;
    payload: IAuthUserInfo;
}

export type AuthLoginActionType = {
    type: typeof AUTH_LOGIN;
    payload: Promise<EmUserProfile>;
}

export function loginUserAction(accessToken: string, refreshToken: string): AuthLoginActionType {
    return {
        type: AUTH_LOGIN.base,
        payload: asyncLoginUser(accessToken, refreshToken)
    };
}

async function asyncLoginUser(accessToken: string, refreshToken: string): Promise<EmUserProfile> {
    const op = new AuthProvider();
    return await op.login(accessToken, refreshToken);
}

export function setAuthUserData(userName: string, accessToken: string, refreshToken: string): SetAuthUserDataType {
    return {
        type: SET_AUTHENTICATED_USER_DATA,
        payload: {
            userName,
            accessToken,
            refreshToken
        }
    };
}

export function didSetUserPreferences(userPreferencesIsSet: boolean): DidSetUserPreferencesType {
    return {
        type: DID_SET_USER_PREFERENCES,
        payload: userPreferencesIsSet
    };
}

export function resetLoggedOutUserDataAction(): ResetLoggedOutUserActionType {
    return {
        type: RESET_LOGGED_OUT_USER_DATA
    };
}
